<template>
    <div>
        <div id="vehiclelist_filter">
            <TableActionHeader @filterChange="(val) => { this.filter = val }" :newButton="false"></TableActionHeader>
        </div>
        <b-table hover striped :items="listData" :fields="fields" :responsive="false" :small="true"
            primary-key="vehicleId" ref="vehicleList" selectable select-mode="multi" @row-selected="onRowSelected"
            :filter="filter" :filter-included-fields="filterOn" :per-page="pagingPerPage" :current-page="currentPage"
            @filtered="onFiltered">
            <template v-slot:cell(vehicleId)="data">
                <span>{{ data.value }}</span>
            </template>
            <template v-slot:cell(vehicleLabel)="data">
                <span class="listNameText">
                    <p class="listNameParag">{{ data.item.vehicleLabel }}</p>
                </span>
            </template>
            <template v-slot:cell(organization)="data">
                {{ data.item.organization }}
            </template>
        </b-table>
        <div class="d-flex justify-content-center">
            <TablePagination :perPage="pagingPerPage" :totalRows="filteredListLength"
                @pageChange="(p) => { this.currentPage = p }">
            </TablePagination>
        </div>
    </div>
</template>

<script>
import realtime from '@/store/realtime/realtime';

export default {
    name: 'VehicleList',
    data() {
        return {
            fields: [
                { key: 'vehicleId', label: 'Id', sortable: true },
                { key: 'vehicleLabel', label: 'Name', sortable: true },
                { key: 'organization', label: 'Organization', sortable: true }
            ],
            currentPage: 1,
            selected: [],
            pagingPerPage: 5,
            filter: null,
            filterOn: ['vehicleId', 'vehicleLabel', 'organization'],
            filteredListLength: 0
        };
    },
    beforeCreate() {
        if (!this.$store.state.realtime) {
            this.$store.registerModule('realtime', realtime);
        }
    },
    created() {
    },
    mounted() {
        if (!this.listData || this.listData.length === 0) {
            this.$store.dispatch('realtime/getVehicles')
                .catch(() => { });
        }
        this.deselectAll();
    },
    computed: {
        listData() {
            return this.$store.state.realtime.vehicles.list;
        },
        listLength() {
            return Array.isArray(this.listData) ? this.listData.length : 0;
        }
    },
    watch: {
        listData: {
            immediate: true,
            handler(newListData) {
                this.filteredListLength = Array.isArray(newListData) ? newListData.length : 0;
            }
        }
    },
    methods: {
        onRowSelected(items) {
            this.selected = items;
        },
        deselectAll() {
            this.$refs.vehicleList.clearSelected();
            this.selected = [];
        },
        getSelectedList() {
            return JSON.parse(JSON.stringify(this.selected));
        },
        onFiltered(filteredItems) {
            this.filteredListLength = filteredItems.length;
            const maxPage = Math.ceil(this.filteredListLength / this.pagingPerPage);
            if (this.currentPage > maxPage && maxPage > 0) {
                this.currentPage = 1;
            }
        }
    }
}
</script>

<style scoped lang="scss">
p {
    margin-bottom: 0.1rem;
}

p .listNameParag {
    margin-bottom: 0.1rem;
}

.listNameText {
    font-weight: bold;
}
</style>